const imprint = {
  title: 'Mentions légales',
  intro:
    'gut geregelt est un fabricant de logiciels suisse et fait partie du groupe Betascale.',
  headquarter: 'Siège',
};

export default imprint;
